// Mock data for Amourduluxe.com
// NOTE: All data here is MOCKED for the frontend-only teaser.

export const LANGUAGES = [
  { code: "fr", label: "Français", flag: "FR" },
  { code: "en", label: "English", flag: "EN" },
  { code: "zh", label: "中文", flag: "ZH" },
];

// UI translations
export const translations = {
  fr: {
    promoBar: "Livraison offerte dès 399€ • Retours gratuits sous 30 jours • Shopping en ligne easy",
    searchPlaceholder: "Rechercher une marque, un article...",
    women: "Femme",
    men: "Homme",
    shoes: "Chaussures",
    bags: "Sacs",
    accessories: "Accessoires",
    perfumes: "Parfums",
    kids: "Enfants",
    drinks: "Vins & Spiritueux",
    hightech: "High-Tech",
    negoce: "Négoce B2B",
    vape: "Cigarettes électroniques",
    b2bBadge: "Pro",
    b2bBanner: "Vente en gros réservée aux professionnels — TPE, PME et grands comptes.",
    moqLabel: "Quantité minimum",
    fromPrice: "À partir de",
    perUnit: "/ unité",
    tieredPricing: "Tarifs dégressifs",
    tierQty: "Quantité",
    tierPrice: "Prix unitaire",
    requestQuote: "Demander un devis",
    quoteTitle: "Demande de devis professionnel",
    quoteSubtitle: "Recevez une offre personnalisée sous 24h ouvrées.",
    companyLabel: "Société / Raison sociale",
    contactLabel: "Nom du contact",
    phoneLabel: "Téléphone",
    desiredQty: "Quantité souhaitée",
    messageLabel: "Message (facultatif)",
    sendQuote: "Envoyer la demande",
    quoteSent: "Demande envoyée ! Notre équipe Négoce vous recontactera.",
    proAccount: "Compte professionnel (B2B)",
    proAccountHint: "Accédez à l'achat en gros Négoce après validation par notre équipe.",
    proPending: "Compte professionnel en attente de validation.",
    proReserved: "Achat direct réservé aux comptes professionnels validés.",
    becomePro: "Créer un compte professionnel",
    moqInput: "Quantité minimum",
    unitInput: "Unité (ex : flacon, carton)",
    tiersInput: "Tarifs dégressifs (ex : 100:39, 300:34)",
    myQuotes: "Mes demandes de devis",
    quoteStatusNew: "En attente",
    quoteStatusHandled: "Traité",
    proValidated: "Compte pro validé",
    proPendingBadge: "Compte pro en attente",
    noQuotes: "Aucune demande de devis pour le moment.",
    ageTitle: "Vérification de l'âge",
    ageQuestion: "Ce produit est réservé aux personnes majeures. Avez-vous 18 ans ou plus ?",
    ageYes: "Oui, j'ai 18 ans ou plus",
    ageNo: "Non",
    ageDenied: "Ce produit est réservé aux personnes majeures (18+).",
    restrictedNote: "Produit réservé aux adultes (18+). L'abus d'alcool / la nicotine est dangereux pour la santé.",
    flavor: "Saveur",
    selectFlavor: "Choisissez une saveur",
    nicotineLabel: "Taux de nicotine",
    contactNav: "Contact",
    contactTitle: "Contactez-nous",
    contactSubtitle: "Une question, une commande, un partenariat ? Notre équipe vous répond sous 24h ouvrées.",
    contactName: "Nom complet",
    contactEmail: "E-mail",
    contactSubject: "Sujet",
    contactMessage: "Votre message",
    contactSend: "Envoyer le message",
    contactSent: "Message envoyé ! Nous vous répondrons très vite.",
    contactInfoTitle: "Nos coordonnées",
    contactEmailLabel: "E-mail",
    contactHoursLabel: "Horaires",
    contactHours: "Du lundi au vendredi, 9h – 18h (CET)",
    contactResponse: "Réponse sous 24h ouvrées",
    contactOnlineTitle: "Shopping en ligne easy",
    contactOnlineText: "Commandez en quelques clics, 24h/24 et 7j/7.",
    contactWhatsappLabel: "WhatsApp",
    contactWhatsappText: "Discutez avec nous en direct",
    vipNav: "Endroits VIP",
    shippingMethodLabel: "Mode de livraison",
    freeShippingNote: "Livraison offerte dès 399 €",
    sale: "Promotions",
    login: "Se connecter",
    cart: "Panier",
    newArrivals: "Nouveautés",
    heroTitle: "L'élégance, réinventée.",
    heroSubtitle: "Découvrez une sélection raffinée de pièces d'exception, choisies avec amour.",
    shopNow: "Découvrir la collection",
    shopWomen: "Boutique Femme",
    shopMen: "Boutique Homme",
    categoriesTitle: "Explorer par catégorie",
    trendingTitle: "Les incontournables du moment",
    editorialTitle: "L'art du raffinement",
    editorialText: "Chaque pièce raconte une histoire. Des matières nobles, des coupes précises, et un savoir-faire qui traverse le temps.",
    lookbookTitle: "Le Lookbook",
    lookbookText: "Une invitation au style : nos silhouettes préférées de la saison.",
    discover: "En savoir plus",
    newsletterTitle: "Rejoignez le Cercle Amourduluxe",
    newsletterText: "Recevez nos nouveautés en avant-première et -15% sur votre première commande.",
    subscribe: "S'inscrire",
    emailPlaceholder: "Votre adresse e-mail",
    viewAll: "Voir tout",
    filters: "Filtres",
    category: "Catégorie",
    all: "Tout",
    priceRange: "Prix",
    sortBy: "Trier par",
    sortPopular: "Popularité",
    sortPriceAsc: "Prix croissant",
    sortPriceDesc: "Prix décroissant",
    sortNew: "Nouveautés",
    products: "articles",
    addToCart: "Ajouter au panier",
    size: "Taille",
    color: "Couleur",
    selectSize: "Choisir une taille",
    description: "Description",
    details: "Détails & entretien",
    delivery: "Livraison & retours",
    deliveryInfo: "Livraison offerte dès 399€. Retours gratuits sous 30 jours.",
    destination: "Destination",
    freeShippingFrom: "Livraison offerte dès 399€",
    only: "Plus que",
    forFreeShipping: "pour la livraison offerte",
    relatedTitle: "Vous aimerez aussi",
    cartTitle: "Votre panier",
    cartEmpty: "Votre panier est vide.",
    continueShopping: "Continuer mes achats",
    subtotal: "Sous-total",
    shipping: "Livraison",
    free: "Offerte",
    total: "Total",
    checkout: "Passer la commande",
    remove: "Retirer",
    quantity: "Quantité",
    orderPlaced: "Merci ! Votre commande a bien été enregistrée.",
    addedToCart: "Ajouté au panier",
    footerAbout: "Amourduluxe",
    footerAboutText: "La maison qui célèbre le luxe accessible et l'élégance intemporelle.",
    footerHelp: "Aide",
    footerCompany: "La Maison",
    footerLegal: "Informations",
    newBadge: "Nouveau",
    saleBadge: "Promo",
    home: "Accueil",
    reviews: "avis",
    signIn: "Connexion",
    signUp: "Créer un compte",
    fullName: "Nom complet",
    emailLabel: "E-mail",
    passwordLabel: "Mot de passe",
    accountBuyer: "Je suis un client",
    accountSeller: "Je suis un vendeur",
    shopNameLabel: "Nom de la boutique",
    shopDescLabel: "Description de la boutique",
    noAccount: "Pas encore de compte ?",
    haveAccount: "Déjà un compte ?",
    logout: "Déconnexion",
    myAccount: "Mon compte",
    myOrders: "Mes commandes",
    sellerSpace: "Espace vendeur",
    adminSpace: "Administration",
    checkoutTitle: "Paiement",
    paymentMethod: "Moyen de paiement",
    card: "Carte bancaire",
    paypal: "PayPal",
    otherPay: "Autre",
    cardNumber: "Numéro de carte",
    expiry: "Expiration",
    cvc: "CVC",
    cardHolder: "Titulaire de la carte",
    payNow: "Payer maintenant",
    noOrders: "Aucune commande pour le moment.",
    status: "Statut",
    paidStatus: "Payé",
    loginRequired: "Connectez-vous pour finaliser votre commande.",
    orderNumber: "Commande",
    mockPaymentNote: "Paiement simulé pour la démo — aucune carte n'est débitée.",
  },
  en: {
    promoBar: "Free delivery from €399 • Free returns within 30 days • Easy online shopping",
    searchPlaceholder: "Search a brand, an item...",
    women: "Women",
    men: "Men",
    shoes: "Shoes",
    bags: "Bags",
    accessories: "Accessories",
    perfumes: "Perfumes",
    kids: "Kids",
    drinks: "Wines & Spirits",
    hightech: "Tech",
    negoce: "B2B Wholesale",
    vape: "E-cigarettes",
    b2bBadge: "Pro",
    b2bBanner: "Wholesale trade reserved for professionals — small businesses, SMEs and key accounts.",
    moqLabel: "Minimum order quantity",
    fromPrice: "From",
    perUnit: "/ unit",
    tieredPricing: "Volume pricing",
    tierQty: "Quantity",
    tierPrice: "Unit price",
    requestQuote: "Request a quote",
    quoteTitle: "Business quote request",
    quoteSubtitle: "Receive a tailored offer within 24 business hours.",
    companyLabel: "Company",
    contactLabel: "Contact name",
    phoneLabel: "Phone",
    desiredQty: "Desired quantity",
    messageLabel: "Message (optional)",
    sendQuote: "Send request",
    quoteSent: "Request sent! Our Wholesale team will get back to you.",
    proAccount: "Professional account (B2B)",
    proAccountHint: "Access Négoce wholesale purchasing after our team validates your account.",
    proPending: "Professional account pending validation.",
    proReserved: "Direct purchase reserved for validated professional accounts.",
    becomePro: "Create a professional account",
    moqInput: "Minimum order quantity",
    unitInput: "Unit (e.g. bottle, case)",
    tiersInput: "Volume pricing (e.g. 100:39, 300:34)",
    myQuotes: "My quote requests",
    quoteStatusNew: "Pending",
    quoteStatusHandled: "Handled",
    proValidated: "Pro account validated",
    proPendingBadge: "Pro account pending",
    noQuotes: "No quote requests yet.",
    ageTitle: "Age verification",
    ageQuestion: "This product is restricted to adults. Are you 18 or older?",
    ageYes: "Yes, I am 18 or older",
    ageNo: "No",
    ageDenied: "This product is restricted to adults (18+).",
    restrictedNote: "Adults only (18+). Alcohol abuse / nicotine is dangerous for your health.",
    flavor: "Flavour",
    selectFlavor: "Choose a flavour",
    nicotineLabel: "Nicotine level",
    contactNav: "Contact",
    contactTitle: "Contact us",
    contactSubtitle: "A question, an order, a partnership? Our team replies within 24 business hours.",
    contactName: "Full name",
    contactEmail: "Email",
    contactSubject: "Subject",
    contactMessage: "Your message",
    contactSend: "Send message",
    contactSent: "Message sent! We'll get back to you shortly.",
    contactInfoTitle: "Get in touch",
    contactEmailLabel: "Email",
    contactHoursLabel: "Hours",
    contactHours: "Monday to Friday, 9am – 6pm (CET)",
    contactResponse: "Reply within 24 business hours",
    contactOnlineTitle: "Easy online shopping",
    contactOnlineText: "Order in a few clicks, 24/7.",
    contactWhatsappLabel: "WhatsApp",
    contactWhatsappText: "Chat with us live",
    vipNav: "VIP places",
    shippingMethodLabel: "Delivery method",
    freeShippingNote: "Free shipping over €399",
    sale: "Sale",
    login: "Sign in",
    cart: "Cart",
    newArrivals: "New in",
    heroTitle: "Elegance, reinvented.",
    heroSubtitle: "Discover a refined selection of exceptional pieces, chosen with love.",
    shopNow: "Explore the collection",
    shopWomen: "Shop Women",
    shopMen: "Shop Men",
    categoriesTitle: "Explore by category",
    trendingTitle: "This season's essentials",
    editorialTitle: "The art of refinement",
    editorialText: "Every piece tells a story. Noble materials, precise cuts, and craftsmanship that stands the test of time.",
    lookbookTitle: "The Lookbook",
    lookbookText: "An invitation to style: our favourite silhouettes of the season.",
    discover: "Learn more",
    newsletterTitle: "Join the Amourduluxe Circle",
    newsletterText: "Get early access to new arrivals and -15% on your first order.",
    subscribe: "Subscribe",
    emailPlaceholder: "Your email address",
    viewAll: "View all",
    filters: "Filters",
    category: "Category",
    all: "All",
    priceRange: "Price",
    sortBy: "Sort by",
    sortPopular: "Popularity",
    sortPriceAsc: "Price: low to high",
    sortPriceDesc: "Price: high to low",
    sortNew: "Newest",
    products: "items",
    addToCart: "Add to cart",
    size: "Size",
    color: "Color",
    selectSize: "Select a size",
    description: "Description",
    details: "Details & care",
    delivery: "Delivery & returns",
    deliveryInfo: "Free delivery from €399. Free returns within 30 days.",
    relatedTitle: "You may also like",
    cartTitle: "Your cart",
    cartEmpty: "Your cart is empty.",
    continueShopping: "Continue shopping",
    subtotal: "Subtotal",
    shipping: "Shipping",
    free: "Free",
    total: "Total",
    checkout: "Checkout",
    remove: "Remove",
    quantity: "Quantity",
    orderPlaced: "Thank you! Your order has been placed.",
    addedToCart: "Added to cart",
    footerAbout: "Amourduluxe",
    footerAboutText: "The house that celebrates accessible luxury and timeless elegance.",
    footerHelp: "Help",
    footerCompany: "The House",
    footerLegal: "Information",
    newBadge: "New",
    saleBadge: "Sale",
    home: "Home",
    reviews: "reviews",
    signIn: "Sign in",
    signUp: "Create account",
    fullName: "Full name",
    emailLabel: "Email",
    passwordLabel: "Password",
    accountBuyer: "I am a customer",
    accountSeller: "I am a seller",
    shopNameLabel: "Shop name",
    shopDescLabel: "Shop description",
    noAccount: "No account yet?",
    haveAccount: "Already have an account?",
    logout: "Log out",
    myAccount: "My account",
    myOrders: "My orders",
    sellerSpace: "Seller space",
    adminSpace: "Admin",
    checkoutTitle: "Payment",
    paymentMethod: "Payment method",
    card: "Credit card",
    paypal: "PayPal",
    otherPay: "Other",
    cardNumber: "Card number",
    expiry: "Expiry",
    cvc: "CVC",
    cardHolder: "Cardholder",
    payNow: "Pay now",
    noOrders: "No orders yet.",
    status: "Status",
    paidStatus: "Paid",
    loginRequired: "Sign in to complete your order.",
    orderNumber: "Order",
    mockPaymentNote: "Simulated payment for the demo — no card is charged.",
  },
  zh: {
    promoBar: "满 €399 免运费 • 30 天内免费退货 • 轻松在线购物",
    searchPlaceholder: "搜索品牌或商品...",
    women: "女士",
    men: "男士",
    shoes: "鞋履",
    bags: "箱包",
    accessories: "配饰",
    perfumes: "香水",
    kids: "童装",
    drinks: "名酿佳饮",
    hightech: "数码科技",
    negoce: "B2B 批发",
    vape: "电子烟",
    b2bBadge: "企业",
    b2bBanner: "面向专业客户的批发贸易 — 小微企业、中小企业及大客户。",
    moqLabel: "最低起订量",
    fromPrice: "起价",
    perUnit: "/ 件",
    tieredPricing: "阶梯价格",
    tierQty: "数量",
    tierPrice: "单价",
    requestQuote: "索取报价",
    quoteTitle: "企业报价申请",
    quoteSubtitle: "24 个工作小时内获得专属报价。",
    companyLabel: "公司名称",
    contactLabel: "联系人",
    phoneLabel: "电话",
    desiredQty: "所需数量",
    messageLabel: "留言（选填）",
    sendQuote: "提交申请",
    quoteSent: "申请已提交！我们的批发团队将与您联系。",
    proAccount: "企业账户 (B2B)",
    proAccountHint: "账户经我们团队审核后即可进行批发采购。",
    proPending: "企业账户待审核。",
    proReserved: "直接购买仅限已审核的企业账户。",
    becomePro: "创建企业账户",
    moqInput: "最低起订量",
    unitInput: "单位（如：瓶、箱）",
    tiersInput: "阶梯价格（如：100:39, 300:34）",
    myQuotes: "我的报价申请",
    quoteStatusNew: "待处理",
    quoteStatusHandled: "已处理",
    proValidated: "企业账户已验证",
    proPendingBadge: "企业账户待审核",
    noQuotes: "暂无报价申请。",
    ageTitle: "年龄验证",
    ageQuestion: "本产品仅限成年人购买。您是否已年满 18 周岁？",
    ageYes: "是，我已年满 18 周岁",
    ageNo: "否",
    ageDenied: "本产品仅限成年人（18+）购买。",
    restrictedNote: "仅限成人（18+）。过量饮酒 / 尼古丁有害健康。",
    flavor: "口味",
    selectFlavor: "请选择口味",
    nicotineLabel: "尼古丁含量",
    contactNav: "联系我们",
    contactTitle: "联系我们",
    contactSubtitle: "有疑问、订单或合作意向？我们的团队将在 24 个工作小时内回复。",
    contactName: "姓名",
    contactEmail: "电子邮箱",
    contactSubject: "主题",
    contactMessage: "您的留言",
    contactSend: "发送留言",
    contactSent: "留言已发送！我们会尽快与您联系。",
    contactInfoTitle: "联系方式",
    contactEmailLabel: "电子邮箱",
    contactHoursLabel: "营业时间",
    contactHours: "周一至周五，9:00 – 18:00（欧洲中部时间）",
    contactResponse: "24 个工作小时内回复",
    contactOnlineTitle: "轻松在线购物",
    contactOnlineText: "几次点击即可下单，全天候 24/7。",
    contactWhatsappLabel: "WhatsApp",
    contactWhatsappText: "与我们实时聊天",
    vipNav: "VIP 去处",
    shippingMethodLabel: "配送方式",
    freeShippingNote: "满 399 € 免运费",
    sale: "促销",
    login: "登录",
    cart: "购物车",
    newArrivals: "新品",
    heroTitle: "重新定义优雅。",
    heroSubtitle: "探索用心甄选的臻品系列。",
    shopNow: "探索系列",
    shopWomen: "选购女士",
    shopMen: "选购男士",
    categoriesTitle: "按类别浏览",
    trendingTitle: "本季必备单品",
    editorialTitle: "精致之艺",
    editorialText: "每一件单品都讲述一个故事。高贵的材质、精准的剪裁，以及经得起时间考验的工艺。",
    lookbookTitle: "造型型录",
    lookbookText: "风格邀约：本季我们最爱的造型。",
    discover: "了解更多",
    newsletterTitle: "加入 Amourduluxe 会员圈",
    newsletterText: "抢先获取新品资讯，首单立享 -15% 优惠。",
    subscribe: "订阅",
    emailPlaceholder: "您的电子邮箱",
    viewAll: "查看全部",
    filters: "筛选",
    category: "类别",
    all: "全部",
    priceRange: "价格",
    sortBy: "排序",
    sortPopular: "人气",
    sortPriceAsc: "价格从低到高",
    sortPriceDesc: "价格从高到低",
    sortNew: "最新",
    products: "件商品",
    addToCart: "加入购物车",
    size: "尺码",
    color: "颜色",
    selectSize: "请选择尺码",
    description: "商品描述",
    details: "细节与保养",
    delivery: "配送与退货",
    deliveryInfo: "满 €399 免运费。30 天内免费退货。",
    destination: "配送目的地",
    freeShippingFrom: "满 €399 免运费",
    only: "再买",
    forFreeShipping: "即可免运费",
    relatedTitle: "您可能还喜欢",
    cartTitle: "您的购物车",
    cartEmpty: "您的购物车是空的。",
    continueShopping: "继续购物",
    subtotal: "小计",
    shipping: "运费",
    free: "免费",
    total: "合计",
    checkout: "结算",
    remove: "移除",
    quantity: "数量",
    orderPlaced: "谢谢！您的订单已提交。",
    addedToCart: "已加入购物车",
    footerAbout: "Amourduluxe",
    footerAboutText: "致力于呈现平价奢华与永恒优雅的时装屋。",
    footerHelp: "帮助",
    footerCompany: "关于我们",
    footerLegal: "信息",
    newBadge: "新品",
    saleBadge: "促销",
    home: "首页",
    reviews: "条评价",
    signIn: "登录",
    signUp: "创建账户",
    fullName: "姓名",
    emailLabel: "电子邮箱",
    passwordLabel: "密码",
    accountBuyer: "我是买家",
    accountSeller: "我是卖家",
    shopNameLabel: "店铺名称",
    shopDescLabel: "店铺简介",
    noAccount: "还没有账户？",
    haveAccount: "已有账户？",
    logout: "退出登录",
    myAccount: "我的账户",
    myOrders: "我的订单",
    sellerSpace: "卖家中心",
    adminSpace: "管理后台",
    checkoutTitle: "支付",
    paymentMethod: "支付方式",
    card: "银行卡",
    paypal: "PayPal",
    otherPay: "其他",
    cardNumber: "卡号",
    expiry: "有效期",
    cvc: "安全码",
    cardHolder: "持卡人",
    payNow: "立即支付",
    noOrders: "暂无订单。",
    status: "状态",
    paidStatus: "已支付",
    loginRequired: "请登录以完成下单。",
    orderNumber: "订单",
    mockPaymentNote: "演示用模拟支付 — 不会实际扣款。",
  },
};

export const categories = [
  { id: "women", key: "women", image: "https://images.unsplash.com/photo-1527203561188-dae1bc1a417f?crop=entropy&cs=srgb&fm=jpg&w=800&q=85" },
  { id: "men", key: "men", image: "https://images.unsplash.com/photo-1617244147299-5ef406921c35?crop=entropy&cs=srgb&fm=jpg&w=800&q=85" },
  { id: "shoes", key: "shoes", image: "https://images.unsplash.com/photo-1581101767113-1677fc2beaa8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBzaG9lc3xlbnwwfHx8fDE3ODQyMzAxOTJ8MA&ixlib=rb-4.1.0&q=85" },
  { id: "bags", key: "bags", image: "https://images.unsplash.com/photo-1584917865442-de89df76afd3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxoYW5kYmFnfGVufDB8fHx8MTc4NDIzMDE5MXww&ixlib=rb-4.1.0&q=85" },
  { id: "accessories", key: "accessories", image: "https://images.unsplash.com/photo-1511499767150-a48a237f0083?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxzdW5nbGFzc2VzfGVufDB8fHx8MTc4NDIzMDE5OHww&ixlib=rb-4.1.0&q=85" },
  { id: "perfumes", key: "perfumes", image: "https://images.unsplash.com/photo-1594035910387-fea47794261f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxwZXJmdW1lJTIwYm90dGxlfGVufDB8fHx8MTc4NDIzMjgxOHww&ixlib=rb-4.1.0&q=85" },
  { id: "kids", key: "kids", image: "https://images.unsplash.com/photo-1601379327928-bedfaf9da2d0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxrbml0d2VhciUyMHN3ZWF0ZXJ8ZW58MHx8fHwxNzg0MjMwMTM1fDA&ixlib=rb-4.1.0&q=85" },
  { id: "drinks", key: "drinks", image: "https://images.unsplash.com/photo-1743184579851-5ec9972100b3?crop=entropy&cs=srgb&fm=jpg&w=800&q=85" },
  { id: "hightech", key: "hightech", image: "https://images.unsplash.com/photo-1504610926078-a1611febcad3?crop=entropy&cs=srgb&fm=jpg&w=800&q=85" },
  { id: "negoce", key: "negoce", image: "https://images.unsplash.com/photo-1553413077-190dd305871c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHx3YXJlaG91c2UlMjBwYWxsZXRzJTIwd2hvbGVzYWxlJTIwZ29vZHN8ZW58MHx8fHwxNzg0NDA5MjMyfDA&ixlib=rb-4.1.0&q=85" },
  { id: "vape", key: "vape", image: "https://images.unsplash.com/photo-1594177914682-d408d96e458b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHx2YXBlJTIwZGV2aWNlJTIwZS1jaWdhcmV0dGV8ZW58MHx8fHwxNzg1MjczOTc3fDA&ixlib=rb-4.1.0&q=85" },
];

const n = (fr, en, zh) => ({ fr, en, zh });

export const products = [
  {
    id: "p1", category: "women", brand: "Maison Lauren",
    name: n("Robe midi en soie plissée", "Pleated silk midi dress", "真丝百褶中长连衣裙"),
    desc: n(
      "Une robe midi fluide en soie plissée, tombé aérien et éclat subtil. Parfaite du bureau au dîner.",
      "A flowing pleated silk midi dress with an airy drape and a subtle sheen. Perfect from desk to dinner.",
      "飘逸的真丝百褶中长连衣裙，垂感轻盈、光泽内敛，从职场到晚宴皆宜。"),
    price: 189, oldPrice: 249, rating: 4.8, reviews: 214, isNew: true, colors: ["#1B1B1B", "#B08D57", "#7A8B8B"], sizes: ["XS", "S", "M", "L", "XL"],
    image: "https://images.unsplash.com/photo-1662532577856-e8ee8b138a8b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBmYXNoaW9uJTIwZWRpdG9yaWFsfGVufDB8fHx8MTc4NDIzMDA4OXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p2", category: "women", brand: "Étoile Paris",
    name: n("Manteau long en laine mélangée", "Long wool-blend coat", "混纺羊毛长大衣"),
    desc: n(
      "Un manteau enveloppant en laine mélangée, coupe droite et col tailleur. La chaleur avec allure.",
      "An enveloping wool-blend coat with a straight cut and tailored collar. Warmth with attitude.",
      "包裹感十足的混纺羊毛大衣，直筒剪裁搭配西装领，温暖又有型。"),
    price: 279, oldPrice: null, rating: 4.9, reviews: 96, isNew: true, colors: ["#3B2F2F", "#C9C4BC"], sizes: ["S", "M", "L", "XL"],
    image: "https://images.unsplash.com/photo-1580478491436-fd6a937acc9e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBmYXNoaW9uJTIwZWRpdG9yaWFsfGVufDB8fHx8MTc4NDIzMDA4OXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p3", category: "women", brand: "Atelier Nord",
    name: n("Pull côtelé en cachemire", "Ribbed cashmere sweater", "罗纹羊绒毛衣"),
    desc: n(
      "Un pull en cachemire d'une douceur incomparable, maille côtelée et coupe intemporelle.",
      "A cashmere sweater of unrivalled softness, with a ribbed knit and timeless fit.",
      "无与伦比柔软的羊绒毛衣，罗纹针织与经典版型。"),
    price: 145, oldPrice: 179, rating: 4.7, reviews: 158, isNew: false, colors: ["#E8DCC8", "#8B5E3C", "#2C2C2C"], sizes: ["XS", "S", "M", "L"],
    image: "https://images.unsplash.com/photo-1574201635302-388dd92a4c3f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxrbml0d2VhciUyMHN3ZWF0ZXJ8ZW58MHx8fHwxNzg0MjMwMTM1fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p4", category: "women", brand: "Maison Lauren",
    name: n("Ensemble tailleur ceinturé", "Belted tailored suit", "系带西装套装"),
    desc: n(
      "Un tailleur structuré à la ceinture marquée, silhouette affirmée et matière impeccable.",
      "A structured suit with a defined waist, an assertive silhouette and impeccable fabric.",
      "结构感十足的收腰西装套装，轮廓利落，面料无可挑剔。"),
    price: 320, oldPrice: null, rating: 4.6, reviews: 72, isNew: true, colors: ["#5A4B3B", "#1B1B1B"], sizes: ["S", "M", "L"],
    image: "https://images.unsplash.com/flagged/photo-1570733117311-d990c3816c47?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBmYXNoaW9uJTIwZWRpdG9yaWFsfGVufDB8fHx8MTc4NDIzMDA4OXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p5", category: "women", brand: "Rive Gauche",
    name: n("Chemisier en satin ivoire", "Ivory satin blouse", "象牙色缎面衬衫"),
    desc: n(
      "Un chemisier en satin à l'éclat délicat, fluide et lumineux, idéal pour sublimer chaque tenue.",
      "A satin blouse with a delicate sheen, fluid and luminous, ideal to elevate any outfit.",
      "光泽细腻的缎面衬衫，飘逸亮泽，轻松点亮每一套穿搭。"),
    price: 98, oldPrice: 129, rating: 4.5, reviews: 134, isNew: false, colors: ["#F4EDE1", "#2C2C2C"], sizes: ["XS", "S", "M", "L", "XL"],
    image: "https://images.unsplash.com/photo-1651761179569-4ba2aa054997?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxhcHBhcmVsJTIwd2hpdGUlMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4NDIzMDEyMHww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p6", category: "men", brand: "Monsieur & Co",
    name: n("Blazer croisé en laine", "Double-breasted wool blazer", "双排扣羊毛西装外套"),
    desc: n(
      "Un blazer croisé au tombé net, pour une allure maîtrisée en toute occasion.",
      "A double-breasted blazer with a crisp drape, for a composed look on any occasion.",
      "垂坠利落的双排扣西装外套，任何场合都从容有型。"),
    price: 259, oldPrice: null, rating: 4.8, reviews: 88, isNew: true, colors: ["#26303B", "#3B2F2F"], sizes: ["46", "48", "50", "52", "54"],
    image: "https://images.unsplash.com/photo-1667283831517-5b747b3c17c8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwzfHxjb2F0JTIwYmxhemVyfGVufDB8fHx8MTc4NDIzMDEyN3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p7", category: "men", brand: "Monsieur & Co",
    name: n("Costume marine sur-mesure", "Made-to-measure navy suit", "藏青定制西装"),
    desc: n(
      "Un costume marine à la coupe ajustée, finitions soignées et confort absolu.",
      "A navy suit with a tailored fit, refined finishings and absolute comfort.",
      "藏青修身西装，做工精细，舒适至上。"),
    price: 449, oldPrice: 549, rating: 4.9, reviews: 61, isNew: false, colors: ["#26303B"], sizes: ["46", "48", "50", "52"],
    image: "https://images.unsplash.com/photo-1740710748146-a15d840d6f40?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHxjb2F0JTIwYmxhemVyfGVufDB8fHx8MTc4NDIzMDEyN3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p8", category: "men", brand: "Atelier Nord",
    name: n("Pull col rond en mérinos", "Merino crew-neck sweater", "美利奴羊毛圆领毛衣"),
    desc: n(
      "Un pull en laine mérinos fine, respirant et raffiné, à porter seul ou superposé.",
      "A fine merino wool sweater, breathable and refined, to wear alone or layered.",
      "精细美利奴羊毛毛衣，透气雅致，单穿或叠搭皆宜。"),
    price: 119, oldPrice: null, rating: 4.6, reviews: 103, isNew: false, colors: ["#7A8B8B", "#3B2F2F", "#C9C4BC"], sizes: ["S", "M", "L", "XL"],
    image: "https://images.unsplash.com/photo-1631541909061-71e349d1f203?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxrbml0d2VhciUyMHN3ZWF0ZXJ8ZW58MHx8fHwxNzg0MjMwMTM1fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p9", category: "men", brand: "Rive Gauche",
    name: n("Chemise blanche en coton", "White cotton shirt", "白色纯棉衬衫"),
    desc: n(
      "La chemise blanche essentielle, coton peigné et col impeccable. Un basique intemporel.",
      "The essential white shirt, in combed cotton with an impeccable collar. A timeless basic.",
      "百搭白衬衫，精梳棉与挺括领型，永不过时的基本款。"),
    price: 79, oldPrice: 99, rating: 4.7, reviews: 176, isNew: false, colors: ["#FFFFFF", "#EAF1F6"], sizes: ["S", "M", "L", "XL", "XXL"],
    image: "https://images.unsplash.com/photo-1645079080647-d9b07aec5367?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw0fHxhcHBhcmVsJTIwd2hpdGUlMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4NDIzMDEyMHww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p10", category: "shoes", brand: "Pas de Velours",
    name: n("Escarpins vernis pointus", "Pointed patent pumps", "尖头漆皮高跟鞋"),
    desc: n(
      "Des escarpins vernis à bout pointu, talon fin et lignes épurées. L'élégance à chaque pas.",
      "Patent pointed-toe pumps with a slim heel and clean lines. Elegance at every step.",
      "尖头漆皮高跟鞋，细跟与利落线条，步步优雅。"),
    price: 165, oldPrice: null, rating: 4.5, reviews: 92, isNew: true, colors: ["#1B1B1B", "#8B1E3F"], sizes: ["36", "37", "38", "39", "40", "41"],
    image: "https://images.unsplash.com/photo-1581101767113-1677fc2beaa8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBzaG9lc3xlbnwwfHx8fDE3ODQyMzAxOTJ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p11", category: "shoes", brand: "Pas de Velours",
    name: n("Sneakers en cuir minimalistes", "Minimalist leather sneakers", "极简真皮运动鞋"),
    desc: n(
      "Des sneakers en cuir lisse à la silhouette épurée, confort quotidien et style discret.",
      "Smooth leather sneakers with a clean silhouette, everyday comfort and understated style.",
      "光面真皮运动鞋，轮廓简洁，日常舒适、低调有型。"),
    price: 135, oldPrice: 169, rating: 4.6, reviews: 148, isNew: false, colors: ["#FFFFFF", "#1B1B1B", "#B08D57"], sizes: ["39", "40", "41", "42", "43", "44"],
    image: "https://images.unsplash.com/photo-1571859856639-d54ab2c18ba0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBzaG9lc3xlbnwwfHx8fDE3ODQyMzAxOTJ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p12", category: "shoes", brand: "Terra Nova",
    name: n("Bottines en cuir grainé", "Grained leather ankle boots", "纹理真皮短靴"),
    desc: n(
      "Des bottines en cuir grainé, semelle robuste et fermeture zippée. Le compagnon de l'automne.",
      "Grained leather ankle boots with a sturdy sole and zip closure. Your autumn companion.",
      "纹理真皮短靴，坚固鞋底与侧拉链，秋日良伴。"),
    price: 199, oldPrice: null, rating: 4.7, reviews: 67, isNew: true, colors: ["#3B2F2F", "#1B1B1B"], sizes: ["36", "37", "38", "39", "40"],
    image: "https://images.pexels.com/photos/34279969/pexels-photo-34279969.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "p13", category: "bags", brand: "Cuir & Or",
    name: n("Sac à main structuré", "Structured handbag", "结构手提包"),
    desc: n(
      "Un sac structuré en cuir de veau, anses rigides et finitions dorées. L'accessoire signature.",
      "A structured calfskin handbag with rigid handles and gold finishings. The signature accessory.",
      "小牛皮结构手提包，硬挺手柄配金色五金，标志性配饰。"),
    price: 245, oldPrice: 299, rating: 4.8, reviews: 121, isNew: true, colors: ["#8B1E3F", "#1B1B1B", "#B08D57"], sizes: [],
    image: "https://images.unsplash.com/photo-1584917865442-de89df76afd3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxoYW5kYmFnfGVufDB8fHx8MTc4NDIzMDE5MXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p14", category: "bags", brand: "Cuir & Or",
    name: n("Pochette du soir dorée", "Golden evening clutch", "金色晚宴手拿包"),
    desc: n(
      "Une pochette du soir à l'éclat doré, format compact et chaîne amovible. Pour briller.",
      "A golden evening clutch with a compact format and removable chain. Made to shine.",
      "金色晚宴手拿包，小巧造型配可拆卸链条，闪耀登场。"),
    price: 129, oldPrice: null, rating: 4.4, reviews: 54, isNew: false, colors: ["#B08D57", "#1B1B1B"], sizes: [],
    image: "https://images.unsplash.com/photo-1614179689702-355944cd0918?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwzfHxoYW5kYmFnfGVufDB8fHx8MTc4NDIzMDE5MXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p15", category: "bags", brand: "Terra Nova",
    name: n("Cabas en cuir souple", "Soft leather tote", "软皮托特包"),
    desc: n(
      "Un cabas spacieux en cuir souple, parfait au quotidien sans sacrifier l'élégance.",
      "A spacious soft leather tote, perfect for everyday without sacrificing elegance.",
      "宽敞的软皮托特包，日常之选又不失优雅。"),
    price: 179, oldPrice: 219, rating: 4.6, reviews: 83, isNew: false, colors: ["#8B5E3C", "#1B1B1B"], sizes: [],
    image: "https://images.unsplash.com/photo-1600857062241-98e5dba7f214?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHw0fHxoYW5kYmFnfGVufDB8fHx8MTc4NDIzMDE5MXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p16", category: "accessories", brand: "Solaire",
    name: n("Lunettes de soleil oversize", "Oversized sunglasses", "大框太阳镜"),
    desc: n(
      "Des lunettes oversize aux verres dégradés, monture légère et protection UV totale.",
      "Oversized sunglasses with gradient lenses, a lightweight frame and full UV protection.",
      "大框太阳镜，渐变镜片、轻盈镜架，全面防紫外线。"),
    price: 89, oldPrice: null, rating: 4.3, reviews: 112, isNew: true, colors: ["#1B1B1B", "#5A4B3B"], sizes: [],
    image: "https://images.unsplash.com/photo-1511499767150-a48a237f0083?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxzdW5nbGFzc2VzfGVufDB8fHx8MTc4NDIzMDE5OHww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p17", category: "accessories", brand: "Horizon",
    name: n("Montre automatique acier", "Steel automatic watch", "钢制自动机械表"),
    desc: n(
      "Une montre automatique au boîtier acier, cadran épuré et bracelet raffiné. Le temps, avec style.",
      "An automatic watch with a steel case, a clean dial and a refined strap. Time, with style.",
      "钢制表壳自动机械表，简洁表盘配精致表带，时间亦有格调。"),
    price: 299, oldPrice: 379, rating: 4.9, reviews: 47, isNew: false, colors: ["#C9C4BC", "#26303B"], sizes: [],
    image: "https://images.unsplash.com/photo-1542496658-e33a6d0d50f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHx3YXRjaHxlbnwwfHx8fDE3ODQyMzAxOTh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p18", category: "accessories", brand: "Éclat",
    name: n("Parure de bijoux dorés", "Golden jewelry set", "金色首饰套装"),
    desc: n(
      "Une parure dorée délicate, collier et boucles assortis. La touche finale qui fait la différence.",
      "A delicate golden set with matching necklace and earrings. The finishing touch that makes the difference.",
      "精致金色首饰套装，项链与耳饰成套，画龙点睛。"),
    price: 75, oldPrice: 95, rating: 4.5, reviews: 89, isNew: true, colors: ["#B08D57"], sizes: [],
    image: "https://images.unsplash.com/photo-1606760227091-3dd870d97f1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwzfHxmYXNoaW9uJTIwYWNjZXNzb3JpZXN8ZW58MHx8fHwxNzg0MjMwMTkxfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p19", category: "perfumes", brand: "Sillage",
    name: n("Nuit Dorée — Eau de Parfum", "Nuit Dorée — Eau de Parfum", "金色夜曲 — 香精"),
    desc: n(
      "Un parfum enveloppant aux notes de vanille, d'ambre et de fleur d'oranger. Un sillage chaleureux qui s'attarde délicatement.",
      "An enveloping fragrance with notes of vanilla, amber and orange blossom. A warm trail that lingers delicately.",
      "以香草、琥珀与橙花为调的迷人香氛，温暖余香久久萦绕。"),
    price: 92, oldPrice: 119, rating: 4.8, reviews: 187, isNew: true, colors: [], sizes: ["50 ml", "100 ml"],
    image: "https://images.unsplash.com/photo-1541643600914-78b084683601?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxwZXJmdW1lJTIwYm90dGxlfGVufDB8fHx8MTc4NDIzMjgxOHww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p20", category: "perfumes", brand: "Sillage",
    name: n("Fleur de Rosée — Eau de Toilette", "Fleur de Rosée — Eau de Toilette", "晨露之花 — 淡香水"),
    desc: n(
      "Une fragrance florale et fraîche, portée par la rose et la pivoine. Légère et lumineuse, comme un matin de printemps.",
      "A fresh floral fragrance carried by rose and peony. Light and luminous, like a spring morning.",
      "以玫瑰与牡丹演绎的清新花香，轻盈明媚，宛若春日清晨。"),
    price: 78, oldPrice: null, rating: 4.6, reviews: 142, isNew: true, colors: [], sizes: ["30 ml", "50 ml", "100 ml"],
    image: "https://images.unsplash.com/photo-1594035910387-fea47794261f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxwZXJmdW1lJTIwYm90dGxlfGVufDB8fHx8MTc4NDIzMjgxOHww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p21", category: "perfumes", brand: "Maison Boisée",
    name: n("Ambre Noir — Parfum boisé", "Ambre Noir — Woody perfume", "黑琥珀 — 木质香精"),
    desc: n(
      "Un parfum masculin intense aux accords de bois de cèdre, de cuir et de poivre noir. Élégant et affirmé.",
      "An intense masculine perfume with accords of cedar wood, leather and black pepper. Elegant and assertive.",
      "以雪松、皮革与黑胡椒交织的浓烈男士香精，优雅而坚定。"),
    price: 105, oldPrice: 135, rating: 4.9, reviews: 96, isNew: false, colors: [], sizes: ["50 ml", "100 ml"],
    image: "https://images.unsplash.com/photo-1523293182086-7651a899d37f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxwZXJmdW1lJTIwYm90dGxlfGVufDB8fHx8MTc4NDIzMjgxOHww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p22", category: "perfumes", brand: "Sillage",
    name: n("Coffret Sillage Précieux", "Sillage Précieux gift set", "臻藏香氛礼盒"),
    desc: n(
      "Un coffret raffiné réunissant trois miniatures signature. L'introduction parfaite à l'univers olfactif de la maison.",
      "A refined gift set bringing together three signature miniatures. The perfect introduction to the house's olfactory universe.",
      "精致礼盒集齐三款招牌小样，是探索本店香氛世界的完美入门。"),
    price: 65, oldPrice: null, rating: 4.7, reviews: 58, isNew: true, colors: [], sizes: [],
    image: "https://images.pexels.com/photos/4735908/pexels-photo-4735908.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "p23", category: "kids", brand: "Petit Nuage",
    name: n("Pull en maille douce", "Soft knit sweater", "柔软针织毛衣"),
    desc: n(
      "Un pull tout doux en coton mélangé, coupe confortable et coloris tendres. Parfait pour les journées fraîches.",
      "A super-soft cotton-blend sweater with a comfy fit and gentle colours. Perfect for cooler days.",
      "混纺棉柔软毛衣，版型舒适、色调温柔，是微凉日子的理想之选。"),
    price: 45, oldPrice: 59, rating: 4.7, reviews: 78, isNew: true, colors: ["#E8DCC8", "#7A8B8B"], sizes: ["2A", "4A", "6A", "8A", "10A"],
    image: "https://images.unsplash.com/photo-1601379327928-bedfaf9da2d0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxrbml0d2VhciUyMHN3ZWF0ZXJ8ZW58MHx8fHwxNzg0MjMwMTM1fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p24", category: "kids", brand: "Petit Nuage",
    name: n("Manteau matelassé", "Quilted coat", "绗缝外套"),
    desc: n(
      "Un manteau matelassé léger et chaud, capuche douillette et fermeture facile. Pour affronter l'hiver avec le sourire.",
      "A light and warm quilted coat with a cosy hood and easy closure. To face winter with a smile.",
      "轻盈保暖的绗缝外套，配舒适连帽与便捷开合，笑迎寒冬。"),
    price: 69, oldPrice: null, rating: 4.6, reviews: 41, isNew: true, colors: ["#26303B", "#8B1E3F"], sizes: ["2A", "4A", "6A", "8A", "10A", "12A"],
    image: "https://images.unsplash.com/photo-1592878956815-2feeac767f7b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHw0fHxjb2F0JTIwYmxhemVyfGVufDB8fHx8MTc4NDIzMDEyN3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p25", category: "kids", brand: "Lili & Léo",
    name: n("Ensemble deux pièces", "Two-piece set", "两件套装"),
    desc: n(
      "Un ensemble coordonné haut et bas, en coton confortable et facile à assortir. L'allure sans effort au quotidien.",
      "A coordinated top-and-bottom set in comfy cotton, easy to mix and match. Effortless everyday style.",
      "上下身协调套装，采用舒适纯棉，易于搭配，轻松演绎日常造型。"),
    price: 52, oldPrice: 69, rating: 4.5, reviews: 63, isNew: false, colors: ["#C9C4BC", "#B08D57"], sizes: ["2A", "4A", "6A", "8A"],
    image: "https://images.unsplash.com/photo-1558769132-cb1aea458c5e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxmYXNoaW9uJTIwY2xvdGhpbmd8ZW58MHx8fHwxNzg0MjMwMTIwfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p26", category: "kids", brand: "Lili & Léo",
    name: n("Chemise en coton bio", "Organic cotton shirt", "有机棉衬衫"),
    desc: n(
      "Une chemise en coton biologique tout doux, coupe légère et boutons faciles. Douce pour la peau et pour la planète.",
      "A super-soft organic cotton shirt with a light fit and easy buttons. Gentle on skin and on the planet.",
      "柔软有机棉衬衫，版型轻盈、纽扣易系，呵护肌肤亦友善地球。"),
    price: 38, oldPrice: null, rating: 4.4, reviews: 52, isNew: true, colors: ["#FFFFFF", "#EAF1F6"], sizes: ["2A", "4A", "6A", "8A", "10A"],
    image: "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxjbG90aGluZyUyMGhhbmdlcnxlbnwwfHx8fDE3ODQyMzAxMzV8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const shippingZones = [
  { id: "fr", name: { fr: "France métropolitaine", en: "Mainland France", zh: "法国本土" }, rate: 4.9 },
  { id: "eu", name: { fr: "Union Européenne", en: "European Union", zh: "欧盟" }, rate: 9.9 },
  { id: "chuk", name: { fr: "Suisse / Royaume-Uni", en: "Switzerland / UK", zh: "瑞士 / 英国" }, rate: 14.9 },
  { id: "intl", name: { fr: "Reste du monde", en: "Rest of the world", zh: "其他国家/地区" }, rate: 24.9 },
];

export const shippingMethods = [
  { id: "mondial_relay", name: { fr: "Mondial Relay", en: "Mondial Relay", zh: "Mondial Relay" }, rate: 3.9, delay: { fr: "En point relais · 3 à 5 jours", en: "Pickup point · 3–5 days", zh: "取货点 · 3–5 天" } },
  { id: "colissimo", name: { fr: "Colissimo", en: "Colissimo", zh: "Colissimo" }, rate: 5.9, delay: { fr: "À domicile · 2 à 3 jours", en: "Home delivery · 2–3 days", zh: "送货上门 · 2–3 天" } },
  { id: "chronopost", name: { fr: "Chronopost", en: "Chronopost", zh: "Chronopost" }, rate: 9.9, delay: { fr: "Express · 24 à 48h", en: "Express · 24–48h", zh: "特快 · 24–48 小时" } },
  { id: "dhl", name: { fr: "DHL Express", en: "DHL Express", zh: "DHL Express" }, rate: 14.9, delay: { fr: "International express · 24 à 72h", en: "International express · 24–72h", zh: "国际特快 · 24–72 小时" } },
];

export const editorialImage = "https://images.unsplash.com/photo-1617244145995-f79f45448c5c?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85";
export const heroImage = "https://images.unsplash.com/photo-1632765866070-3fadf25d3d5b?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85";
export const heroSecondary = "https://images.unsplash.com/photo-1583147610149-78ac5cb5a303?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85";
export const lookbookWoman = "https://images.unsplash.com/photo-1571513800374-df1bbe650e56?crop=entropy&cs=srgb&fm=jpg&w=900&q=85";
export const lookbookMan = "https://images.unsplash.com/photo-1618886614638-80e3c103d31a?crop=entropy&cs=srgb&fm=jpg&w=900&q=85";
